'use client';

import { useState, useEffect } from 'react';


export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    { label: 'About',    href: '#about' },
    { label: 'Services', href: '#services' },
    { label: 'Process',  href: '#process' },
    { label: 'FAQ',      href: '#faq' },
    { label: 'Contact',  href: '#contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 bg-white transition-shadow duration-300 ${
        scrolled ? 'header-scrolled' : ''
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 h-[72px] flex items-center justify-between">
        {/* Logo */}
        <a href="#hero" className="flex items-center gap-2 no-underline">
          <span
            style={{
              fontFamily: '"DM Sans", sans-serif',
              fontWeight: 800,
              fontSize: '18px',
              color: '#1F3A8A',
              letterSpacing: '-0.02em',
            }}
          >
            CARTELIX
          </span>
          <span
            style={{
              fontFamily: '"DM Sans", sans-serif',
              fontWeight: 500,
              fontSize: '12px',
              color: '#6B7280',
              letterSpacing: '0.12em',
              marginTop: '2px',
            }}
          >
            LLC
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks?.map((link) => (
            <a
              key={link?.href}
              href={link?.href}
              className="text-sm font-semibold text-ink-mid hover:text-brand-primary transition-colors duration-200"
              style={{ fontFamily: '"DM Sans", sans-serif' }}
            >
              {link?.label}
            </a>
          ))}
        </div>

        {/* CTA */}
        <a
          href="#contact"
          className="hidden md:inline-flex btn-primary text-sm"
          style={{ padding: '10px 22px' }}
        >
          Get a Quote
        </a>

        {/* Mobile Toggle */}
        <button
          className="md:hidden p-2 rounded-lg text-ink-dark"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          ) : (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="18" x2="20" y2="18"/></svg>
          )}
        </button>
      </nav>
      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="mobile-menu md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navLinks?.map((link) => (
            <a
              key={link?.href}
              href={link?.href}
              className="text-sm font-semibold text-ink-mid hover:text-brand-primary py-2"
              style={{ fontFamily: '"DM Sans", sans-serif' }}
              onClick={() => setMobileOpen(false)}
            >
              {link?.label}
            </a>
          ))}
          <a
            href="#contact"
            className="btn-primary text-sm text-center"
            style={{ padding: '12px 20px' }}
            onClick={() => setMobileOpen(false)}
          >
            Get a Quote
          </a>
        </div>
      )}
    </header>
  );
}